var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlBideonFilled = function SvgHtlBideonFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.518 14.005a.5.5 0 0 1-.5-.5v-6.4a.5.5 0 0 1 .5-.5h.484V5.255a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-1.5v.852h5.7v-2.28c-.011-.438-.17-.58-.629-.58a.586.586 0 0 0-.63.63.5.5 0 0 1-1 0 1.584 1.584 0 0 1 1.63-1.63 1.957 1.957 0 0 0 2.257 0 1.584 1.584 0 0 1 1.63 1.63.5.5 0 0 1-1 0 .586.586 0 0 0-.63-.63c-.476 0-.628.152-.628.63v2.224h1.782a1.465 1.465 0 0 1 1.171.578 2.2 2.2 0 0 1 .171 2.026 4.43 4.43 0 0 1-5.2 3.231c.036.292.093.607.172.958a.5.5 0 0 1-.488.611H2.518Z"
  })));
};
export default SvgHtlBideonFilled;